
export default function Footer() {
  return (
    <footer className="bg-[#5A4033] text-white py-12 px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="mb-6">
          <img
            src="https://static.readdy.ai/image/be74474a88e32cc40cdef43b4d914c46/765474251b75aae3d75c66971441b410.png"
            alt="おうちの相談室"
            className="h-20 w-auto mb-4"
          />
          <p className="text-base mb-4 md:block hidden">
            住まいの不安を確かな未来へ。プロと歩む「おうちの相談室」
          </p>
          <p className="text-base mb-4 md:hidden block">
            住まいの不安を確かな未来へ。<br />
            プロと歩む「おうちの相談室」
          </p>
          <p className="text-sm mb-2">
            【 赤坂オフィス 】東京都港区赤坂4-7-6
          </p>
          <a
            href="https://lin.ee/luTEHR8"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm hover:text-[#F2A67E] transition-colors cursor-pointer flex items-center gap-2"
          >
            <i className="ri-line-fill text-lg"></i>
            LINE公式アカウント
          </a>
        </div>

        <div className="border-t border-white/20 pt-6 flex flex-col-reverse md:flex-row justify-between items-center gap-4">
          <p className="text-sm">
            © 2025 おうちの相談室. All rights reserved.
          </p>
          <a
            href="/privacy-policy"
            className="text-sm hover:text-[#F2A67E] transition-colors cursor-pointer"
          >
            プライバシーポリシー
          </a>
        </div>
      </div>
    </footer>
  );
}